import { render, staticRenderFns } from "./root.vue?vue&type=template&id=b77f7136"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=b77f7136&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports